var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat208(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_208"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_208",
    "data-name": 208,
    className: "cls-2",
    d: "M87.42,96.72c3.12-2.72,2.27-8,1.25-11.46-4.14-14.1-11.5-27.52-17.82-40.71C53.62,8.63,52.37,3.53,46,2.27c-17-3.36-40.07,26.66-34.82,37.31,1.62,3.26,5.64,4,8.86,4.62,4.95,1,9.93,1.58,14.57,3.7,7.31,3.35,10.77,10.48,14.09,17.34,3.88,8,7.93,16.78,14.87,22.86C67.67,91.7,82,101.46,87.42,96.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat208);
export default __webpack_public_path__ + "static/media/cat_208.954e94c9136d036c15d7bd9bc36d4a52.svg";
export { ForwardRef as ReactComponent };